import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../../providers/appProvider';

import cl from "./Copy.module.css"
import Plus from "../../../../assets/Icon/Plus"; 
import Modal from '../../../UI/Modal/Modal'
import Pen from "../../../../assets/Icon/Pen";
import Select from "react-select";
import MultiSelect from '../../../UI/Inputs/MultiSelect';
import { selectStyle } from './selectStyle';
import { Link } from 'react-router-dom'; 


const QuotationCopyModal = ({ QuotationService, defaultQuotation }) => {
    const initEditPrice = (Quotation) => {
        return {
            id: 0,
            quotation_id: Quotation.quotation_id,
            seller_id: Quotation.seller_id,
            status_id: Quotation.status_id,
            user_id: Quotation.user_id,

            sender_country_id: Quotation.sender_country_id,
            reciever_country_id: Quotation.reciever_country_id,
            type_id: Quotation.type_id, // Select transportation id
            created_at: Quotation.created_at || '',
            updated_at: Quotation.updated_at || '',

            icoterm_id: Quotation.icoterm_id,
            land_subtype_id: Quotation.land_subtype_id,
            railway_subtype_id: Quotation.railway_subtype_id,
            marine_line_id: Quotation.marine_line_id,
            period_start_at: Quotation.period_start_at || '',
            period_end_at: Quotation.period_end_at || '',
        }
    }

    const initialTypeOptions = [
        { value: 0, label: 'საზღვაო' },
        { value: 1, label: 'სახმელეთო' },
        { value: 2, label: 'სარკინიგზო' },
        { value: 3, label: 'საჰაერო' },
    ];

    const marineSubtype = [
        { value: 0, label: 'FCL' },
        { value: 1, label: 'LCL' },
        { value: 2, label: 'Oversized' },
    ];
    
    const landSubtype = [
        { value: 0, label: 'FTL' },
        { value: 1, label: 'LTL' },
        { value: 2, label: 'FCL' },
        { value: 3, label: 'Oversized' },
    ];

    const railwaySubtype = [
        { value: 0, label: 'FCL' },
        { value: 1, label: 'LCL' },
        { value: 2, label: 'Wagon' },
        { value: 3, label: 'Cistern' },
        { value: 4, label: 'Oversized' },
    ];

    const incotermTypes = [
        { value: 0, label: 'FOB' },
        { value: 1, label: 'FCA' },
        { value: 2, label: 'ExW' },
        { value: 3, label: 'DAP' },
        { value: 4, label: 'CIF' },
    ];

    const statusTypes = [
        { value: 0, label: ' ' },
        { value: 1, label: 'წაგებული' },
        { value: 2, label: 'მიმდინარე' },
        { value: 3, label: 'მოგებული' },
      ];


    const [isModalOpen, setIsModalOpen] = useState(false);
    const { appState, app } = useContext(AppContext);
    const [newQuotation, setNewQuotation] = useState(initEditPrice(defaultQuotation))
    const [typeOptions, setTypeOptions] = useState(initialTypeOptions);
    const marines = appState.marines.map((marine) => ({ value: marine.id, label: marine.name }));
    const [validates, setValidates] = useState({})

    useEffect(() => {
        setNewQuotation(defaultQuotation)
    }, [defaultQuotation]);

    const handleTypeIdChange = (selectedOption) => {
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            type_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleMarineSubtypeChange = (selectedOption) => {
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            marine_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleIncotermChange = (selectedOption) => {
       setNewQuotation(prevPrice => ({
            ...prevPrice,
            icoterm_id: selectedOption ? selectedOption.value : 0
        }));
    };
    const handleLandSubtypeChange = (selectedOption) => {
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            land_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleRailwaySubtypeChange = (selectedOption) => {
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            railway_subtype_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const handleStatusTypeChange = (selectedOption) => {
        setNewQuotation(prevPrice => ({
            ...prevPrice,
            status_id: selectedOption ? selectedOption.value : 0
        }));
    };

    const openAdd = () => {
        setNewQuotation(initEditPrice(defaultQuotation))
        setIsModalOpen(true)
    }

    const saveHandle = () => {
        const isValidate = validateQuotation(newQuotation)

        if (isValidate === true) {
            newQuotation.user_id = appState.user.firstname + ' ' + appState.user.lastname
            newQuotation.created_at = new Date().toLocaleString()
            QuotationService.add(newQuotation)
            setIsModalOpen(false)
        } else {
            console.log("Not valid or error")
            // setIsFirstValidated(true)
        }
    };

    const validateQuotation = (Quotation) => {
        const messages = {};

        if (Quotation.sender_country_id < 1) {
            messages.sender_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (Quotation.reciever_country_id < 1) {
            messages.reciever_country_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (Quotation.marine_line_id < 1 && Quotation.type_id === 0 ) {
            messages.marine_line_id = { message: 'სავალდებულოა', isValid: false };
        }

        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    const stylesError = {
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)', // Apply blue border on hover if focused, otherwise regular border
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),
    };
    return(
        <div>
            <span className={cl.editBtn} onClick={() => openAdd()} >
                <Pen /> კოპირება
            </span>

            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div className={cl.modalHead} >
                    <h3><span className={cl.iconHead} > <Pen /></span> კოპირება</h3>
                </div>

                <fieldset className={cl.formField} style={{marginTop: '15px'}}>
                    <legend>ჩატვირთვის ქვეყანა</legend>
                    <Select
                        options={appState.countries}
                        value={appState.countries.find(country => country.id === newQuotation.sender_country_id) || null}
                        onChange={(selectedOption) => {
                            setNewQuotation(prevState => ({
                            ...prevState,
                            sender_country_id: selectedOption ? selectedOption.id : 0,
                            }));
                        }}
                        placeholder="ქვეყანა"
                        styles={selectStyle}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}  
                    />

                </fieldset>

                <fieldset className={cl.formField}>
                    <legend>მიმღების ქვეყანა</legend>
                    <Select
                        options={appState.countries}
                        value={appState.countries.find(country => country.id === newQuotation.reciever_country_id) || null}
                        onChange={(selectedOption) => {
                            setNewQuotation(prevState => ({
                            ...prevState,
                            reciever_country_id: selectedOption ? selectedOption.id : 0,
                            }));
                        }}
                        placeholder="ქვეყანა"
                        styles={selectStyle}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}  
                    />
                </fieldset>

                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>სტატუსი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={selectStyle}
                            options={statusTypes}
                            value={statusTypes.find(option => option.value === newQuotation.status_id)}
                            onChange={handleStatusTypeChange}
                            placeholder="ტიპი"
                        />
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>


                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>გადაზიდვის ტიპი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={selectStyle}
                            options={typeOptions}
                            value={typeOptions.find(option => option.value === newQuotation.type_id)}
                            onChange={handleTypeIdChange}
                            placeholder="ტიპი"
                        />
                    </div>
                    <div style={{ width: "50%" }}>
                    </div>
                </fieldset>

                {newQuotation.type_id === 0 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>

                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={marineSubtype}
                                value={marineSubtype.find(option => option.value === newQuotation.marine_subtype_id)}
                                onChange={handleMarineSubtypeChange}
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newQuotation.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                ) : newQuotation.type_id == 1 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>

                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={landSubtype}
                                value={landSubtype.find(option => option.value === newQuotation.land_subtype_id)}
                                onChange={handleLandSubtypeChange}
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newQuotation.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                ) : newQuotation.type_id == 2 ? (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%" }}>
                            <legend>გადაზიდვის ქვე-ტიპი</legend>
                            <Select
                                styles={selectStyle}
                                options={railwaySubtype}
                                value={railwaySubtype.find(option => option.value === newQuotation.railway_subtype_id)}
                                onChange={handleRailwaySubtypeChange}
                                placeholder="ტიპი"
                            />
                        </div>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newQuotation.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                    </fieldset>
                )
                : (
                    <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                        <div style={{ width: "50%", position: "relative" }}>
                            <legend>Incoterms</legend>
                            <Select
                                styles={selectStyle}
                                options={incotermTypes}
                                value={incotermTypes.find(option => option.value === newQuotation.icoterm_id)}
                                onChange={handleIncotermChange}
                                placeholder="Incoterms"
                            />
                        </div>
                        <div style={{ width: "50%" }}></div>
                    </fieldset>
                )}


                <fieldset style={{ display: "flex", gap: '10px' }}  className={cl.formField}>
                    <legend>საზღვაო ხაზი</legend>

                    <div style={{ width: "50%" }}>
                        <Select
                            styles={validates && validates.marine_line_id ? { ...selectStyle, ...stylesError } : selectStyle}
                            options={marines}
                            value={marines.find(option => option.value === newQuotation.marine_line_id)}
                            onChange={(selectedOption) => {
                                setNewQuotation(prevState => ({
                                    ...prevState,
                                    marine_line_id: selectedOption ? selectedOption.value : 0,
                                }));

                                if (selectedOption) {

                                    setNewQuotation(prevState => ({
                                        ...prevState,
                                    }));
                                } else {
                                    setTypeOptions(initialTypeOptions);
                                }

                            }}
                            placeholder="საზღვაო ხაზი"
                            isClearable={true}
                        />
                    </div>

                    <div style={{ width: "50%", display: 'flex', alignItems: 'center' }}>
                        <Link className={cl.DefaultAddBtn} to="/databases/marine_lines">
                            <span className={cl.icon} > <Plus /></span>
                        </Link> 
                    </div>

                </fieldset>

                <span onClick={saveHandle} className={cl.btnPrimary}>შენახვა</span>

            </Modal>
        </div>
    )
}

export default QuotationCopyModal;